import { AlertCircle } from 'lucide-react';

interface ErrorSummaryProps {
  errors: Record<string, string>;
  touched: Record<string, boolean>;
}

export function ErrorSummary({ errors, touched }: ErrorSummaryProps) {
  const visibleErrors = Object.entries(errors)
    .filter(([key, error]) => touched[key] && error)
    .map(([key, error]) => ({ field: key, message: error }));

  if (visibleErrors.length === 0) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-start gap-3">
        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-red-900 mb-2">
            Please fix {visibleErrors.length} {visibleErrors.length === 1 ? 'error' : 'errors'} below:
          </h3>
          <ul className="space-y-1">
            {visibleErrors.map((error, index) => (
              <li key={index} className="text-xs text-red-700 flex items-center gap-2">
                <span className="inline-block w-1 h-1 rounded-full bg-red-600" />
                {error.message}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
